import { memo, useCallback, useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import CircularProgress from './CircularProgress';

const DELAYED_MESSAGE_TIMEOUT_MS = 10_000;

interface AdCreationProgressProps {
  onLaunchMoreAds: () => void;
  message?: string;
}

const AdCreationProgress = memo(({
  onLaunchMoreAds,
  message = 'Ad creation is in progress.',
}: AdCreationProgressProps) => {
  const [showDelayedMessage, setShowDelayedMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDelayedMessage(true);
    }, DELAYED_MESSAGE_TIMEOUT_MS);

    return () => { clearTimeout(timer); };
  }, []);

  const handleLaunchMoreAds = useCallback(() => {
    onLaunchMoreAds();
  }, [onLaunchMoreAds]);

  return (
    <CircularProgress>
      <Typography variant="body1" textAlign="center">
        {message}
        {showDelayedMessage && (
          <>
            <br />
            In some cases, it may take longer due to a large number of ads in a
            single session.
          </>
        )}
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLaunchMoreAds}>
        Launch more ads
      </Button>
    </CircularProgress>
  );
});

AdCreationProgress.displayName = 'AdCreationProgress';

export default AdCreationProgress;
